import { render, staticRenderFns } from "./upload-cover-note.vue?vue&type=template&id=066ac6ee&scoped=true&"
import script from "./upload-cover-note.vue?vue&type=script&lang=js&"
export * from "./upload-cover-note.vue?vue&type=script&lang=js&"
import style0 from "./upload-cover-note.vue?vue&type=style&index=0&id=066ac6ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066ac6ee",
  null
  
)

export default component.exports